











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListTag, ListItems } from './types';

@Component
export default class AppList extends Vue {
  @Prop({ type: String, default: 'ul' })
  readonly tag!: ListTag;

  @Prop({ type: [Array, Object], required: true })
  readonly items!: ListItems;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppList/AppList.vue